import React, { useEffect, useState } from 'react'
import TopTitleBar from '../TopTitleBar'
import { useLocation, useParams } from "react-router-dom";
import { BASE_URL, GET_VERIFIER_FORM, USER_TOKEN } from '../../../../Utils/constant'
import API from '../../../../ApiConfig'
import Each from '../../../../components/Each';
import { Link } from "react-router-dom";
import dayjs from 'dayjs';
import cogoToast from 'cogo-toast-react-17-fix';
import { Delay } from '../../../../Utils/helper';
import Loader from '../../../../components/Loader';
import { Icon } from 'react-icons-kit';
import { arrow_right } from 'react-icons-kit/ikons/arrow_right';
import SlideUpWrapper from '../../../../components/Transitions/SlideUpWrapper';
import useRefreshToken from '../../../../Hooks/usegenerateToken';

export default function FormDetails() {
    const location = useLocation();
    const formType = location.state?.formType || 2
    // console.log(formType);

    useRefreshToken(BASE_URL + USER_TOKEN)
    const { form_id } = useParams()
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)
    useEffect(() => {
        getFormDetails()
    }, [])
    async function getFormDetails() {
        setLoading(true)
        await Delay()
        API.get(GET_VERIFIER_FORM + form_id)
            .then(res => {
                setLoading(false)
                if (res.data.status === 200) {
                    let temp = res.data.data
                    let result = []
                    Object.keys(temp).map(item => {
                        result = [...result, ...temp[item]]
                    })
                    setData(result)

                }
            })
            .catch(err => {
                console.log(err)
                setLoading(false)
                cogoToast.error('Something went wrong while fetching details!')
            })
    }
    return (
        <div style={{width:"100%"}}>
        <SlideUpWrapper direction='slide-left'>
            <>

                <TopTitleBar isChild >
                    <h2 className="topTitleBarText"> <Link className="secondaryButton1" style={{ textDecoration: "none", color: "#1c64f2" }} to="../forms/myRequests">All Requests</Link>
                        {data && data.length > 0 ? <span className="secondaryButton1"> <Icon icon={arrow_right} /> {data?.[0]?.form_name}</span> : null}  </h2>
                </TopTitleBar>
                {/* <Loader isOpen={loading} /> */}
                <div className="credentials-table">
                    <table>
                        <tr className="credentials-header bg-lgray">
                            <th className="credentials-th">
                                <div className="credentials-table-text">Field</div>
                            </th>
                            {/* <th className="credentials-th">
                                <div className="credentials-table-text">Total verifications</div>
                            </th> */}
                            {
                                formType && formType == 1 ?
                                    <th className="credentials-th"><div className="credentials-table-text">Documents</div></th>
                                    :
                                    null
                            }
                            <th className="credentials-th">
                                <div className="credentials-table-text">Created At</div>
                                <img className="chevronSortIcon" alt="" src="/chevronsort.svg" />
                            </th>

                        </tr>
                        <tbody>
                            {loading ?
                                (
                                    [...Array(2)].map((_, index) => (
                                        <tr className="credentials-header">
                                            <td className="credentials-th flex-grow-2">
                                                <div className="credentials-table-text">
                                                    <div className="shimmer" style={{ width: '7rem' }}></div>
                                                </div>
                                            </td>

                                            <td className="credentials-th flex-grow-2">
                                                <div className="credentials-table-text">
                                                    <div className="shimmer" style={{ width: '7rem' }}></div>
                                                </div>
                                            </td>
                                            <td className="credentials-th">
                                                <div className="credentials-table-text">
                                                    <div className="shimmer" style={{ width: '7rem' }}></div>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                ) :
                                (
                                    <Each of={data} render={(item, index) => (
                                        <tr className="credentials-header" key={index}>
                                            <td className="credentials-th">
                                                <div className="credentials-table-text">{item.doc_field_name}</div>
                                            </td>

                                            {/* <td className="credentials-th">
                                                <div className="credentials-table-text">{item.no_of_submissions}</div>
                                            </td> */}
                                            {
                                                formType && formType == 1 ?
                                                    <td className="credentials-th">

                                                        <div className="credentials-table-text">{item.linked_documents.join(", ")}</div>
                                                    </td>
                                                    :
                                                    null
                                            }
                                            <td className="credentials-th">
                                                <div className="credentials-table-text">{dayjs(item.created_at).format('DD MMM YYYY')}</div>
                                            </td>
                                        </tr>
                                    )} />)
                            }
                        </tbody>
                    </table>
                </div>
            </>
        </SlideUpWrapper>
        </div>
    )
}
